const TrainerFollowUp = (props) => {
  const { followup } = props;

  function formatDateOnly(dateString) {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (isNaN(date)) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
  }

  return (
    <div className="trainer-followup">
      <div className="trainer-followup-title">Follow Up</div>
      <div className="trainer-data-fields">
        {followup.length > 0 ? (
          followup.map((follow, i) => (
            <div key={i} className="trainer-data">
              <div className="trainer-field-row">
                <div className="trainer-field-label">Effettuato</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {follow.effettuato ? "Si" : "No"}
                  </span>
                </div>
              </div>

              <div className="trainer-field-row">
                <div className="trainer-field-label">Data Formazione</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {formatDateOnly(follow.dataFormazione)}
                  </span>
                </div>
              </div>

              <div className="trainer-field-row">
                <div className="trainer-field-label">Location</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">{follow.location}</span>
                </div>
              </div>

              <div className="trainer-field-row">
                <div className="trainer-field-label">Note</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">{follow.note}</span>
                </div>
              </div>

              <div className="trainer-field-row">
                <div className="trainer-field-label">Admin</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {follow.autore?.nome} {follow.autore?.cognome}
                  </span>
                </div>
              </div>

              <div className="trainer-field-row">
                <div className="trainer-field-label">Email Admin</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {follow.autore?.email}
                  </span>
                </div>
              </div>

              <div className="trainer-field-row">
                <div className="trainer-field-label">Tipologia Admin</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {follow.autore?.tipologia}
                  </span>
                </div>
              </div>

              <div className="trainer-field-row">
                <div className="trainer-field-label">Descrizione Admin</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {follow.autore?.descrizione}
                  </span>
                </div>
              </div>

              <div className="trainer-field-row">
                <div className="trainer-field-label">Data Creazione Admin</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {formatDateOnly(follow.autore?.dataCreazione)}
                  </span>
                </div>
              </div>

              <div className="trainer-field-row">
                <div className="trainer-field-label">
                  Data Ultima Modifica Admin
                </div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {formatDateOnly(follow.autore?.dataUltimaModifica)}
                  </span>
                </div>
              </div>

              <div className="trainer-field-row">
                <div className="trainer-field-label">
                  Autore Ultima Modifica Email
                </div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {follow.autore?.autoreUltimaModifica}
                  </span>
                </div>
              </div>

              <div className="trainer-field-row">
                <div className="trainer-field-label">
                  Autore Ultima Modifica Nome
                </div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {follow.autore?.nome} {follow.autore?.cognome}
                  </span>
                </div>
              </div>

              <div className="trainer-field-row">
                <div className="trainer-field-label">Admin Abilitato</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {follow.autore?.enabled ? "Si" : "No"}
                  </span>
                </div>
              </div>

              <div className="trainer-field-row">
                <div className="trainer-field-label">Admin Bloccato</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">
                    {follow.autore?.locked ? "Si" : "No"}
                  </span>
                </div>
              </div>

              {follow.autore?.sedi && follow.autore.sedi.length > 0 && (
                <div className="trainer-field-row">
                  <div className="trainer-field-label">Sedi Admin</div>
                  <div className="trainer-field-value">
                    <span className="trainer-span-value">
                      {follow.autore.sedi.join(", ")}
                    </span>
                  </div>
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="no-data">Nessun follow up disponibile.</div>
        )}
      </div>
    </div>
  );
};

export default TrainerFollowUp;
